import { TherapistSessionLocationFilter } from '@/src/domains/therapist-filters/components/TherapistSessionLocationFilter/TherapistSessionLocationFilter'
import { TherapistSessionTypeFilter } from '@/src/domains/therapist-filters/components/TherapistSessionTypeFilter'
import { SessionTypeFilter } from '@/src/domains/therapist-filters/constants'
import { useTherapistSessionTypeFilter } from '@/src/domains/therapist-filters/hooks/useTherapistSessionTypeFilter'

import { useTherapistSessionLocationFilter } from './TherapistSessionFilterMenuContent.hooks'

const typeForLocality = [SessionTypeFilter.OFFLINE, SessionTypeFilter.HYBRID]

export const TherapistSessionFilterMenuContent = () => {
  const { type, handleTypeFilter } = useTherapistSessionTypeFilter()
  const { serviceId, location, handleLocationFilter } = useTherapistSessionLocationFilter()

  return (
    <>
      <TherapistSessionTypeFilter value={type} callback={handleTypeFilter} />
      {typeForLocality.includes(type as SessionTypeFilter) ? (
        <TherapistSessionLocationFilter serviceId={serviceId} value={location} callback={handleLocationFilter} />
      ) : null}
    </>
  )
}
